/* Chakki Peesing product card — variant switch, per-kg price, quantity selector,
   add to cart (same flow as homepage "Our Products"), haptic tap, Sold Out state,
   desktop hover image, mobile "Load more", "Bought before" / Reorder for repeat customers */
(() => {
  if (customElements.get('cp-card')) return;

  // Mobile par ADD ke baad full-screen cart drawer kholna hai? (false = sirf "Added ✓" + cart count update)
  const OPEN_DRAWER_ON_MOBILE = false;
  const MAX_QTY = 99;

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const isDesktop = () => window.matchMedia('(min-width: 750px)').matches;
  const fmt = (paise) => '₹' + (paise / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
  const fmtRound = (rupees) => '₹' + Math.round(rupees).toLocaleString('en-IN');

  // Light haptic tap on phones (Android Chrome; iOS ignores it silently)
  const buzz = () => {
    try {
      if (navigator.vibrate && window.matchMedia('(pointer: coarse)').matches) navigator.vibrate(12);
    } catch (e) {
      /* ignore */
    }
  };

  // "Trial Pack (750G)", "2.5KG", "4.5KG*2", "500ML", "100g", "1.05kg / Fine" → grams or ml
  const parsePack = (title) => {
    const m = String(title).match(/(\d+(?:\.\d+)?)\s*(kg|gms?|g|ml|ltr|l)\b(?:\s*[*x×]\s*(\d+))?/i);
    if (!m) return null;
    const n = parseFloat(m[1]) * (m[3] ? Number(m[3]) : 1);
    const u = m[2].toLowerCase();
    if (u === 'kg') return { kind: 'g', qty: n * 1000 };
    if (u === 'g' || u === 'gm' || u === 'gms') return { kind: 'g', qty: n };
    if (u === 'l' || u === 'ltr') return { kind: 'ml', qty: n * 1000 };
    return { kind: 'ml', qty: n };
  };
  // rupees per kg (solids) or per 100ml (liquids)
  const unitPrice = (v) => {
    if (!v.pack || !v.pack.qty) return null;
    const rupees = v.p / 100;
    return v.pack.kind === 'g' ? rupees / (v.pack.qty / 1000) : rupees / (v.pack.qty / 100);
  };

  const refreshBubble = async () => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    try {
      const data = await fetch(`${window.location.pathname}?sections=cart-icon-bubble`).then((r) => r.json());
      const doc = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
      const inner = doc.querySelector('.shopify-section');
      bubble.innerHTML = inner ? inner.innerHTML : data['cart-icon-bubble'];
    } catch (e) {
      /* ignore */
    }
  };

  const broadcast = (variantId) => {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cp-card', productVariantId: variantId });
    }
    document.dispatchEvent(new CustomEvent('cp:cart-updated', { detail: { variantId } }));
  };

  // Logged-in customer's past purchases (snippets/cp-bought-data.liquid): productId → last-bought variantId
  let boughtMap = null;
  const getBought = () => {
    if (boughtMap) return boughtMap;
    boughtMap = {};
    const el = document.getElementById('cp-bought-data');
    if (!el) return boughtMap;
    try {
      JSON.parse(el.textContent).forEach((pair) => {
        const pid = String(pair[0]);
        if (!(pid in boughtMap)) boughtMap[pid] = Number(pair[1]); // newest order wins
      });
    } catch (e) {
      /* ignore */
    }
    return boughtMap;
  };

  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Fly-to-cart: product photo flies into the visible cart icon, which then bounces
  const visibleCartIcon = () => {
    const els = document.querySelectorAll('#cart-icon-bubble, a[href$="/cart"]');
    for (const el of els) {
      const r = el.getBoundingClientRect();
      if (r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth) return el;
    }
    return null;
  };
  const flyToCart = (img) => {
    if (!img || reduceMotion() || typeof document.body.animate !== 'function') return;
    const target = visibleCartIcon();
    if (!target) return;
    const from = img.getBoundingClientRect();
    const to = target.getBoundingClientRect();
    const size = Math.min(72, from.width * 0.45);
    const ghost = document.createElement('img');
    ghost.src = img.currentSrc || img.src;
    ghost.alt = '';
    ghost.setAttribute('aria-hidden', 'true');
    ghost.className = 'cpc-fly';
    ghost.style.width = ghost.style.height = size + 'px';
    const x0 = from.left + from.width / 2 - size / 2;
    const y0 = from.top + from.height / 2 - size / 2;
    const dx = to.left + to.width / 2 - size / 2 - x0;
    const dy = to.top + to.height / 2 - size / 2 - y0;
    ghost.style.left = x0 + 'px';
    ghost.style.top = y0 + 'px';
    document.body.appendChild(ghost);
    const anim = ghost.animate(
      [
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: `translate(${dx * 0.55}px, ${dy * 0.55 - 60}px) scale(0.7)`, opacity: 1, offset: 0.55 },
        { transform: `translate(${dx}px, ${dy}px) scale(0.18)`, opacity: 0.35 },
      ],
      { duration: 700, easing: 'cubic-bezier(.45,.05,.55,.95)' }
    );
    anim.onfinish = () => {
      ghost.remove();
      target.animate(
        [{ transform: 'scale(1)' }, { transform: 'scale(1.28)' }, { transform: 'scale(0.92)' }, { transform: 'scale(1)' }],
        { duration: 420, easing: 'ease-out' }
      );
    };
  };

  // Gentle fade-up for cards as they scroll into view (incl. "Load more" cards).
  // Skipped when the theme's own scroll animation is on for that card, or reduced motion is set.
  let revealBatch = 0;
  const revealObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            revealBatch = 0;
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const el = entry.target;
              el.style.setProperty('--cpc-delay', Math.min(revealBatch++, 5) * 70 + 'ms');
              el.classList.add('cpc--in');
              revealObserver.unobserve(el);
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
        )
      : null;
  const setupReveal = (card) => {
    if (!revealObserver || reduceMotion()) return;
    if (card.closest('.cpu')) return; // "Buy again" row scrolls sideways: never hide those cards
    const li = card.closest('li');
    if (li && li.classList.contains('scroll-trigger')) return;
    const r = card.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) return; // already on screen: no flash
    card.classList.add('cpc--pre');
    revealObserver.observe(card);
  };

  class CpCard extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      let data = { title: '', variants: [] };
      try {
        data = JSON.parse(this.querySelector('[data-cpc-data]').textContent);
      } catch (e) {
        /* ignore */
      }
      this.productTitle = data.title;
      this.$ = (sel) => this.querySelector(sel);
      this.select = this.$('[data-cpc-select]');

      // Variant titles come from the <option> text (not duplicated in the JSON → lighter HTML)
      const optTitle = {};
      if (this.select) this.select.querySelectorAll('option').forEach((o) => (optTitle[o.value] = o.textContent));
      this.variants = (data.variants || []).map((v) => ({ ...v, t: optTitle[v.id] || '', pack: parsePack(optTitle[v.id] || '') }));
      this.computeBestValue();
      this.addBtn = this.$('[data-cpc-add]');
      this.addText = this.$('[data-cpc-add-text]');
      this.qtyBox = this.$('.cpc__qty');
      this.qtyEl = this.$('[data-cpc-qty]');
      this.decBtn = this.$('[data-cpc-dec]');
      this.incBtn = this.$('[data-cpc-inc]');
      this.qty = 1;
      this.variantId = this.select ? Number(this.select.value) : this.variants[0] && this.variants[0].id;

      // Repeat customer: "Bought before" badge + last-bought pack pre-selected (if still in stock)
      const pid = this.dataset.productId;
      const bought = getBought();
      if (pid && pid in bought) {
        this.boughtVariant = bought[pid];
        const badge = this.$('[data-cpc-bought]');
        if (badge) badge.hidden = false;
        const last = this.variants.find((v) => v.id === this.boughtVariant);
        if (this.select && last && last.a) {
          this.select.value = String(last.id);
          this.variantId = last.id;
        }
      }

      // (Best value is shown only as the pill on the dropdown — no extra text inside the option)

      if (this.select) {
        this.select.addEventListener('change', () => {
          this.variantId = Number(this.select.value);
          this.render();
        });
      }
      this.decBtn.addEventListener('click', () => this.setQty(this.qty - 1));
      this.incBtn.addEventListener('click', () => this.setQty(this.qty + 1));
      this.addBtn.addEventListener('click', () => this.add());

      // Desktop hover: doosri photo pehli baar hover par hi load hoti hai (extra data nahi)
      const alt = this.querySelector('.cpc__img--alt');
      if (alt) {
        const loadAlt = () => {
          if (alt.dataset.loaded) return;
          alt.dataset.loaded = '1';
          alt.addEventListener('load', () => alt.classList.add('is-loaded'), { once: true });
          alt.sizes = alt.dataset.sizes;
          alt.srcset = alt.dataset.srcset;
          alt.src = alt.dataset.src;
        };
        this.addEventListener('pointerenter', (e) => {
          if (e.pointerType === 'mouse') loadAlt();
        });
      }

      this.render();
      setupReveal(this);
    }

    get variant() {
      return this.variants.find((v) => v.id === this.variantId) || this.variants[0];
    }

    // Cheapest per-kg pack gets "Best value" — only if it saves at least 5% vs the costliest per-kg pack
    computeBestValue() {
      const priced = this.variants.filter((v) => v.a).map((v) => ({ id: v.id, u: unitPrice(v) })).filter((x) => x.u);
      this.bestId = null;
      if (priced.length < 2) return;
      const min = priced.reduce((a, b) => (b.u < a.u ? b : a));
      const max = Math.max(...priced.map((x) => x.u));
      if (min.u <= max * 0.95) this.bestId = min.id;
    }

    render() {
      const v = this.variant;
      if (!v) return;
      const hasOff = v.c > v.p;

      this.$('[data-cpc-price]').textContent = fmt(v.p);
      // Clean look: strike-through MRP only from 5% off, "% OFF" badge only from 10% off (no "1% OFF")
      const pct = hasOff ? Math.round(((v.c - v.p) * 100) / v.c) : 0;
      const mrp = this.$('[data-cpc-mrp]');
      mrp.hidden = pct < 5;
      this.$('.cpc__off').hidden = pct < 10;
      if (hasOff) {
        mrp.textContent = fmt(v.c);
        this.$('[data-cpc-off]').textContent = pct + '%';
      }

      const u = unitPrice(v);
      this.$('[data-cpc-unit]').textContent = u ? fmtRound(u) + (v.pack.kind === 'g' ? '/kg' : '/100ml') : '';
      // Pills inside the size box: "Try first" (trial pack, new customers only) wins over "Best value"
      const showTry = /trial/i.test(v.t || '') && !this.boughtVariant;
      const tryPill = this.$('[data-cpc-try]');
      if (tryPill) tryPill.hidden = !showTry;
      const bestPill = this.$('[data-cpc-best]');
      if (bestPill) bestPill.hidden = showTry || !(this.bestId && this.bestId === v.id);

      const pop = this.$('.pop-club-listing');
      if (pop) pop.setAttribute('price', (v.p / 100).toFixed(2));

      this.addBtn.disabled = !v.a;
      this.qtyBox.classList.toggle('is-disabled', !v.a);
      this.setLabel(this.defaultLabel());
    }

    // "Reorder" when the selected pack is the one this customer bought last time
    defaultLabel() {
      const v = this.variant;
      if (!v || !v.a) return 'Sold Out';
      return this.boughtVariant && this.boughtVariant === v.id ? 'Reorder' : 'Add to Cart';
    }

    setQty(q, silent) {
      this.qty = Math.min(MAX_QTY, Math.max(1, q));
      this.qtyEl.textContent = this.qty;
      this.decBtn.disabled = this.qty <= 1;
      this.incBtn.disabled = this.qty >= MAX_QTY;
      if (!silent) buzz();
    }

    setLabel(text) {
      // Mobile card is narrow: "Add" instead of "Add to Cart" (screen readers still get the full label)
      this.addText.textContent = text === 'Add to Cart' && !isDesktop() ? 'Add' : text;
      const label =
        text === 'Add to Cart'
          ? 'Add ' + this.productTitle + ' to cart'
          : text === 'Reorder'
            ? 'Reorder ' + this.productTitle
            : text;
      this.addBtn.setAttribute('aria-label', label);
    }

    feedback(cls, text, ms) {
      clearTimeout(this._fbTimer);
      this.addBtn.classList.remove('is-added', 'is-error');
      this.addBtn.classList.add(cls);
      this.setLabel(text);
      this._fbTimer = setTimeout(() => {
        this.addBtn.classList.remove(cls);
        this.setLabel(this.defaultLabel());
      }, ms);
    }

    // Mobile: small "✓ Added · Cart ₹1,240 (3 items)" pill above the button for ~2 seconds
    async showCartToast() {
      let cart;
      try {
        cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      } catch (e) {
        return;
      }
      if (!cart || typeof cart.total_price !== 'number') return;
      const host = this.$('.cpc__cart-row');
      if (!host) return;
      let toast = this.$('.cpc__toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'cpc__toast';
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        host.appendChild(toast);
      }
      const items = cart.item_count || 0;
      toast.textContent = '✓ Added · Cart ' + fmt(cart.total_price) + ' (' + items + (items === 1 ? ' item)' : ' items)');
      toast.classList.remove('is-show');
      void toast.offsetWidth; // restart the pop-in animation
      toast.classList.add('is-show');
      clearTimeout(this._toastTimer);
      this._toastTimer = setTimeout(() => toast.classList.remove('is-show'), 2200);
    }

    // Adds the chosen quantity. Button shows "Added ✓" instantly; request runs in the background.
    add() {
      const v = this.variant;
      if (!v || !v.a || this._adding) return;
      const qty = this.qty;
      buzz();
      this.feedback('is-added', 'Added ✓', 1600);
      flyToCart(this.querySelector('.cpc__img:not(.cpc__img--alt)'));

      const cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const openDrawer =
        (isDesktop() || OPEN_DRAWER_ON_MOBILE) && cartEl && typeof cartEl.renderContents === 'function';
      const sections =
        openDrawer && typeof cartEl.getSectionsToRender === 'function'
          ? cartEl.getSectionsToRender().map((s) => s.id)
          : [];

      this._adding = true;
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: jsonHeaders,
        body: JSON.stringify({ id: v.id, quantity: qty, sections, sections_url: window.location.pathname }),
      })
        .then((r) => r.json())
        .then((data) => {
          if (data.status) throw new Error(data.description || data.message || 'Add failed');

          // Meta Pixel — same event the homepage "Our Products" section sends
          try {
            if (typeof window.fbq === 'function') {
              window.fbq('track', 'AddToCart', {
                content_ids: [String(v.id)],
                content_name: this.productTitle,
                content_type: 'product',
                value: (v.p / 100) * qty,
                currency: 'INR',
              });
            }
          } catch (e) {
            /* ignore */
          }

          try {
            if (openDrawer && data.sections) {
              cartEl.classList.remove('is-empty');
              cartEl.renderContents(data);
            } else {
              refreshBubble();
            }
          } catch (drawerErr) {
            console.warn('[cp-card] drawer update failed', drawerErr);
            refreshBubble();
          }

          broadcast(v.id);
          this.setQty(1, true); // reset like the homepage section
          // mobile: drawer doesn't open → the sticky cart bar updates (or, if it isn't on the page, a small toast)
          // confirm the add with the small "✓ Added · Cart ₹X" toast (mobile + desktop; GoKwik hides the theme cart popup)
          this.showCartToast();
        })
        .catch((e) => {
          console.warn('[cp-card]', e.message || e);
          this.feedback('is-error', 'Try again', 2200);
        })
        .finally(() => {
          this._adding = false;
        });
    }
  }

  customElements.define('cp-card', CpCard);

  // Mobile "Load more": next page ke products isi grid mein jod deta hai.
  // Back button se wapas aane par utne hi products dobara load karke wahi scroll position laata hai.
  const cplmKey = () => 'cplm:' + location.pathname + location.search;
  let cplmBooted = false; // first <cp-load-more> of this page load (filters re-render new ones)
  const readState = () => {
    try {
      return JSON.parse(sessionStorage.getItem(cplmKey()) || '{}');
    } catch (e) {
      return {};
    }
  };
  const writeState = (patch) => {
    try {
      sessionStorage.setItem(cplmKey(), JSON.stringify(Object.assign(readState(), patch)));
    } catch (e) {
      /* private mode etc. — feature silently off */
    }
  };
  const isBackForward = () => {
    try {
      const nav = performance.getEntriesByType('navigation')[0];
      return !!nav && nav.type === 'back_forward';
    } catch (e) {
      return false;
    }
  };

  class CpLoadMore extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.btn = this.querySelector('[data-cplm-btn]');
      this.countEl = this.querySelector('[data-cplm-count]');
      this.barEl = this.querySelector('[data-cplm-bar]');
      this.total = Number(this.dataset.total) || 0;
      if (this.btn) this.btn.addEventListener('click', () => this.load());

      if (this.dataset.page !== '1') return;
      if (!cplmBooted) {
        cplmBooted = true;
        // Remember scroll position whenever the shopper leaves the page
        window.addEventListener('pagehide', () => writeState({ y: window.scrollY }));
        if (isBackForward()) {
          this.restore();
          return;
        }
      }
      writeState({ loads: 0, y: 0 }); // fresh visit (or filters changed)
    }

    async restore() {
      const state = readState();
      const loads = Number(state.loads) || 0;
      if (!loads) return;
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      for (let i = 0; i < loads; i++) {
        const ok = await this.load(true);
        if (!ok) break;
      }
      requestAnimationFrame(() => window.scrollTo(0, Number(state.y) || 0));
    }

    async load(restoring) {
      const url = this.dataset.next;
      if (!url || this._busy) return false;
      this._busy = true;
      this.btn.disabled = true;
      this.btn.textContent = 'Loading…';
      let ok = false;
      try {
        const res = await fetch(url, { credentials: 'same-origin' });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const grid = (this.closest('.collection') || document).querySelector('.product-grid');
        // only the main grid of the next page (not other product sections)
        const src = doc.getElementById('ProductGridContainer') || doc;
        src.querySelectorAll('.product-grid > li').forEach((li) => {
          li.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
          grid.appendChild(document.adoptNode(li));
        });

        const shown = Math.min(grid.children.length, this.total);
        if (this.countEl) this.countEl.textContent = 'Showing ' + shown + ' of ' + this.total + ' products';
        if (this.barEl && this.total) this.barEl.style.width = (shown / this.total) * 100 + '%';

        const nextEl = doc.querySelector('cp-load-more');
        const nextUrl = nextEl ? nextEl.dataset.next : '';
        if (nextUrl) {
          this.dataset.next = nextUrl;
          this.btn.disabled = false;
          this.btn.textContent = 'Load more';
        } else {
          this.dataset.next = '';
          this.classList.add('is-done');
          if (this.countEl) this.countEl.textContent = 'All ' + this.total + ' products shown';
        }
        if (!restoring) writeState({ loads: (Number(readState().loads) || 0) + 1 });
        ok = true;
      } catch (e) {
        console.warn('[cp-load-more]', e);
        this.btn.disabled = false;
        this.btn.textContent = 'Try again';
      } finally {
        this._busy = false;
      }
      return ok;
    }
  }

  if (!customElements.get('cp-load-more')) customElements.define('cp-load-more', CpLoadMore);

  // "Back to top" button — appears after scrolling down on collection / search pages
  const initBackToTop = () => {
    if (document.querySelector('.cpbtt') || !document.querySelector('cp-card')) return;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cpbtt';
    btn.setAttribute('aria-label', 'Back to top');
    btn.hidden = true;
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5"/><path d="M5 12l7-7 7 7"/></svg>';
    btn.addEventListener('click', () => {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
    document.body.appendChild(btn);
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        btn.hidden = window.scrollY < 1200;
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBackToTop);
  else initBackToTop();

})();
